// https://vuex.vuejs.org/zh-cn/intro.html
// make sure to call Vue.use(Vuex) if using a module system
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
    apiHeader: '',
    dataPool: {}
  },
  mutations: {
    increment: (state) => {
      const obj = state
      obj.count += 1
    },
    decrement: (state) => {
      const obj = state
      obj.count -= 1
    },
    setApiHeader: (state, a) => {
      const obj = state
      obj.apiHeader = a
    },
    setKey: (state, payload) => {
      Vue.set(state.dataPool,payload[0],payload[1])
    }

  },
  getters: {
    getKey: (state) => (key) => {
      const obj = state
      return obj.dataPool[key]
    }
  }
})

export function setAppData (key, value) {
  store.commit('setKey', [key, value])
}

export function getAppData (key) {
  return store.getters.getKey(key)
}
export  function isVaild(key) {
    if (typeof(key)==='undefined'){
      return false
    }
    if(key === null){
      return false
    }
    return true
}
export default {
  store,
  setAppData,
  getAppData,
    isVaild
}
